/**
 * typeSelectPanel.jsx
 *
 * @Author: apple
 * @Date: 2017/12/14 13:20
 */

import React from 'react';
import moment from 'moment';
import ChevronLeft from '../icons/internals/ChevronLeft';
import ChevronRight from '../icons/internals/ChevronRight';
import Button, { IconButton } from '../button';

const sign = {
  prev: -1,
  next: 1,
};

const nextType = {
  time: 'date',
  date: 'month',
  month: 'year',
  year: 'year',
};
function getTitle(date, type) {
  if (type === 'time') {
    return date.format('YYYY-MM-DD');
  }
  if (type === 'date') {
    return date.format('YYYY-MM');
  }
  if (type === 'month') {
    return date.format('YYYY');
  }
  const currentYear = date.year();
  const startOfDecade = Math.floor(currentYear / 10) * 10;
  const endOfDecade = Math.floor(currentYear / 10 + 1) * 10;
  return `${startOfDecade} - ${endOfDecade}`;
}
/**
 * @ignore
 * */
export default class TypeSelect extends React.PureComponent {
  handlePanelDateChange = type => {
    const { onPanelDateChange, panelDate, panelType } = this.props;
    const newDate = moment(panelDate);
    if (panelType === 'date') {
      newDate.add(sign[type], 'month');
    } else if (panelType === 'month') {
      newDate.add(sign[type], 'year');
    } else if (panelType === 'year') {
      newDate.add(sign[type] * 10, 'year');
    }
    onPanelDateChange && onPanelDateChange(newDate);
  };

  render() {
    const {
      onPanelTypeChange,
      panelType,
      prefixCls,
      panelDate,
      disabledMonth,
      disabledYear,
      rangeType,
    } = this.props;
    const headPrefixCls = `${prefixCls}-head`;
    const title = getTitle(panelDate, panelType);
    let disabledCondition = rangeType;
    if (disabledCondition && panelType === 'date') {
      disabledCondition = disabledMonth;
    } else if (disabledCondition && (panelType === 'month' || panelType === 'year')) {
      disabledCondition = disabledYear;
    } else {
      disabledCondition = null;
    }
    const prevDisabled =
      disabledCondition &&
      disabledCondition(
        panelType === 'date'
          ? moment(panelDate)
              .subtract(1, 'month')
              .startOf('month')
          : panelType === 'month'
          ? moment(panelDate)
              .subtract(1, 'year')
              .startOf('year')
          : moment(panelDate)
              .subtract((panelDate.year() % 10) + 1, 'year')
              .startOf('year'),
      );
    const nextDisabled =
      disabledCondition &&
      disabledCondition(
        panelType === 'date'
          ? moment(panelDate)
              .add(1, 'month')
              .startOf('month')
          : panelType === 'month'
          ? moment(panelDate)
              .add(1, 'year')
              .startOf('year')
          : moment(panelDate)
              .add(10 - (panelDate.year() % 10), 'year')
              .startOf('year'),
      );

    const Title = panelType === 'year' ? 'span' : Button;
    return (
      <div className={headPrefixCls}>
        <IconButton
          disabled={prevDisabled || panelType === 'time'}
          className={`${prefixCls}-prev`}
          variant="text"
          onClick={() => this.handlePanelDateChange('prev')}
          ref={prevBtn => (this.prevBtn = prevBtn)}>
          <ChevronLeft />
        </IconButton>
        <Title
          variant="text"
          className={`${headPrefixCls}-title ${headPrefixCls}-${panelType}-title`}
          onClick={e => {
            e.stopPropagation();
            onPanelTypeChange && onPanelTypeChange(nextType[panelType]);
          }}>
          {title}
        </Title>

        <IconButton
          disabled={nextDisabled || panelType === 'time'}
          className={`${prefixCls}-next`}
          variant="text"
          onClick={() => this.handlePanelDateChange('next')}>
          <ChevronRight />
        </IconButton>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/datePicker/TypeSelect.jsx